/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseCategoryFieldAnzeige } from './DatabaseCategoryFieldAnzeige';
import {
    DatabaseCategoryFieldAnzeigeFromJSON,
    DatabaseCategoryFieldAnzeigeFromJSONTyped,
    DatabaseCategoryFieldAnzeigeToJSON,
} from './DatabaseCategoryFieldAnzeige';
import type { DatabaseCategoryFieldLook } from './DatabaseCategoryFieldLook';
import {
    DatabaseCategoryFieldLookFromJSON,
    DatabaseCategoryFieldLookFromJSONTyped,
    DatabaseCategoryFieldLookToJSON,
} from './DatabaseCategoryFieldLook';
import type { DatabaseCategoryFieldOption } from './DatabaseCategoryFieldOption';
import {
    DatabaseCategoryFieldOptionFromJSON,
    DatabaseCategoryFieldOptionFromJSONTyped,
    DatabaseCategoryFieldOptionToJSON,
} from './DatabaseCategoryFieldOption';
import type { DatabaseCategoryFieldOrientation } from './DatabaseCategoryFieldOrientation';
import {
    DatabaseCategoryFieldOrientationFromJSON,
    DatabaseCategoryFieldOrientationFromJSONTyped,
    DatabaseCategoryFieldOrientationToJSON,
} from './DatabaseCategoryFieldOrientation';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseCategoryField
 */
export interface DatabaseCategoryField extends DatabaseField {
    /**
     * 
     * @type {Array<DatabaseCategoryFieldOption>}
     * @memberof DatabaseCategoryField
     */
    content?: Array<DatabaseCategoryFieldOption>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseCategoryField
     */
    defaultSelection?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseCategoryField
     */
    allowMultipleChoice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseCategoryField
     */
    allowNew?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryField
     */
    dependsOn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseCategoryField
     */
    withPlaceholder?: boolean;
    /**
     * 
     * @type {DatabaseCategoryFieldLook}
     * @memberof DatabaseCategoryField
     */
    type?: DatabaseCategoryFieldLook;
    /**
     * 
     * @type {DatabaseCategoryFieldOrientation}
     * @memberof DatabaseCategoryField
     */
    orientation?: DatabaseCategoryFieldOrientation;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseCategoryField
     */
    nutzung?: Array<string>;
    /**
     * 
     * @type {DatabaseCategoryFieldAnzeige}
     * @memberof DatabaseCategoryField
     */
    anzeige?: DatabaseCategoryFieldAnzeige;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryField
     */
    berechnungsMethode?: string;
    /**
     * Wenn true, werden neu hinzugefügte Optionen automatisch alphabetisch in die Liste einsortiert (statt angehängt).
     * @type {boolean}
     * @memberof DatabaseCategoryField
     */
    autoSortOptions?: boolean;
}

/**
 * Check if a given object implements the DatabaseCategoryField interface.
 */
export function instanceOfDatabaseCategoryField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCategoryFieldFromJSON(json: any): DatabaseCategoryField {
    return DatabaseCategoryFieldFromJSONTyped(json, false);
}

export function DatabaseCategoryFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCategoryField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(DatabaseCategoryFieldOptionFromJSON)),
        'defaultSelection': !exists(json, 'defaultSelection') ? undefined : json['defaultSelection'],
        'allowMultipleChoice': !exists(json, 'allowMultipleChoice') ? undefined : json['allowMultipleChoice'],
        'allowNew': !exists(json, 'allowNew') ? undefined : json['allowNew'],
        'dependsOn': !exists(json, 'dependsOn') ? undefined : json['dependsOn'],
        'withPlaceholder': !exists(json, 'withPlaceholder') ? undefined : json['withPlaceholder'],
        'type': !exists(json, 'type') ? undefined : DatabaseCategoryFieldLookFromJSON(json['type']),
        'orientation': !exists(json, 'orientation') ? undefined : DatabaseCategoryFieldOrientationFromJSON(json['orientation']),
        'nutzung': !exists(json, 'nutzung') ? undefined : json['nutzung'],
        'anzeige': !exists(json, 'anzeige') ? undefined : DatabaseCategoryFieldAnzeigeFromJSON(json['anzeige']),
        'berechnungsMethode': !exists(json, 'berechnungsMethode') ? undefined : json['berechnungsMethode'],
        'autoSortOptions': !exists(json, 'autoSortOptions') ? undefined : json['autoSortOptions'],
    };
}

export function DatabaseCategoryFieldToJSON(value?: DatabaseCategoryField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(DatabaseCategoryFieldOptionToJSON)),
        'defaultSelection': value.defaultSelection,
        'allowMultipleChoice': value.allowMultipleChoice,
        'allowNew': value.allowNew,
        'dependsOn': value.dependsOn,
        'withPlaceholder': value.withPlaceholder,
        'type': DatabaseCategoryFieldLookToJSON(value.type),
        'orientation': DatabaseCategoryFieldOrientationToJSON(value.orientation),
        'nutzung': value.nutzung,
        'anzeige': DatabaseCategoryFieldAnzeigeToJSON(value.anzeige),
        'berechnungsMethode': value.berechnungsMethode,
        'autoSortOptions': value.autoSortOptions,
    };
}

